// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5i-2";
export var blackBorderOnHover = "_5i-7";
export var cell = "_5i-6";
export var cellContainer = "_5i-3";
export var checked = "_5i-8";
export var disabled = "_5i-5";
export var featuredIconCellContainer = "_5i-9";
export var featuredIconTextContainer = "_5i-b";
export var featuredIconWrapper = "_5i-a";
export var noBorder = "_5i-c";
export var orangeSelectedRow = "_e6-3";
export var overflowableText = "_5i-0";
export var overflowableTextContainer = "_5i-1";
export var row = "_5j-0";
export var rowCheckboxCell = "_5i-4";
export var selectableTable = "_e6-2";